/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * Information about a facet in a search result
 * @export
 * @interface SearchFacet
 */
export interface SearchFacet  {
    /**
     * 
     * @type {string}
     * @memberof SearchFacet
     */
    name: string;
    /**
     * Total number of entries for this facet
     * @type {number}
     * @memberof SearchFacet
     */
    count: number;
    /**
     * Dictionary of entries for this facet
     * @type {{ [key: string]: number; }}
     * @memberof SearchFacet
     */
    entries: { [key: string]: number; };
    /**
     * Number of documents that have no value for this facet. Only present if the facet was requested with missing counts.
     * @type {number}
     * @memberof SearchFacet
     */
    missing?: number;
}

/**
 * Check if a given object implements the SearchFacet interface.
 */
export function instanceOfSearchFacet(value: object): value is SearchFacet {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function SearchFacetFromJSON(json: any): SearchFacet {
    return SearchFacetFromJSONTyped(json, false);
}

export function SearchFacetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchFacet {
    if (json == null) {
        return json;
    }
    return {
        
                  'name': json['name'],
                  'count': json['count'],
                  'entries': json['entries'],
                  'missing': json['missing'] == null ? undefined : json['missing'],
    };
}

export function SearchFacetToJSON(json: any): SearchFacet {
    return SearchFacetToJSONTyped(json, false);
}

export function SearchFacetToJSONTyped(value?: SearchFacet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'count': value['count'],
        'entries': value['entries'],
        'missing': value['missing'],
    };
}


